import React from "react";
import { Column } from "@vp/swan";
import { ProductBuilderSelection } from "../../../../types/ProductBuilderTypes";
import { getTextBoxPadding } from "../../../../utils/RangeAttributes";
import "../../styles/Selector.scss";
import { TemplateOptionColorSwatch } from "./TemplateOptionColorSwatch";
import { SelectionType } from "../../../../types/DesignOptionTypes";
interface SelectorProps {
  builderSelection: ProductBuilderSelection;
  selectorIndex: number;
  disabled: boolean;
  removePadding: boolean;
  onChange: (value: string | null) => void;
}

const TemplateOptionSelector = (props: SelectorProps) => {
  const {
    builderSelection: templateSelections,
    selectorIndex,
    removePadding,
    disabled,
    onChange,
  } = props;
  const selectionStyle = templateSelections?.selectionStyle;

  if (!templateSelections) {
    return <></>;
  }

  const showIncompatibleValue = selectorIndex === 0;

  return (
    <Column
      span={selectionStyle === SelectionType.TEXT_BOX ? 6 : 12}
      spanXs={selectionStyle === SelectionType.TEXT_BOX ? 6 : 12}
      className={`selector-column ${getTextBoxPadding(
        selectionStyle,
        removePadding,
        templateSelections
      )}`}
    >
      {selectionStyle === SelectionType.SWATCHES && (
        <TemplateOptionColorSwatch
          selectionData={templateSelections}
          showIncompatibleValues={showIncompatibleValue}
          disabled={disabled}
          onChange={onChange}
          selectorIndex={0}
        ></TemplateOptionColorSwatch>
      )}
    </Column>
  );
};

export default TemplateOptionSelector;
